import { HeaderWrapper } from "components/styles/styles";
import OrdersLogo from 'assets/images/logo.png'
const Header = () => {
  return (
    <HeaderWrapper>
      <img src={OrdersLogo} alt="orders-logo"/>
    </HeaderWrapper>
  )
}

export default Header;